<template>
  <div class="top-bar" :class="{ 'mobile-top-bar': isMobile }">
    <div class="left" @click="linkTo('new-index2')">
      <i class="el-icon-house"></i>
      <span class="home-page">首页</span>
    </div>
    <div class="right" :class="{ 'mobile-right': isMobile }">
      <!-- 移动端显示菜单图标 -->

      <div v-if="isMobile" class="mobile-menu-icon" @click="toggleMenu">
        <span class="home-page">菜单</span>
        <i class="el-icon-menu"></i>
      </div>

      <!-- PC端完整菜单 -->
      <div v-else class="desktop-menu">
        <span class="to-pre-order" @click="linkTo('pre-order-list')"> 预下单 ({{cartNumber}})</span> |
        <span>{{getPhone(true)}}</span> |
        <span class="to-order" @click="linkTo('new-user-orders')">我的订单</span> |
        <span class="to-mine" @click="linkTo('personal-center')">个人中心</span> |
        <span class="to-member" @click="linkTo('new-member')">我的会员</span> |
        <span class="to-member" @click="linkTo('new-index')">切换旧版</span> |
        <span class="to-member" @click="linkToAnalysis()">数据分析</span> |
        <span class="to-member" @click="loginOut()">退出</span>

      </div>

      <!-- 移动端侧滑菜单 - 使用之前版本的分组结构 -->
      <transition name="slide-fade">
        <div v-if="isMobile && menuVisible" class="mobile-menu-overlay" @click="toggleMenu">
          <div class="mobile-menu-content" @click.stop>
            <div class="mobile-menu-header">
              <img src="@/assets/images/吉祥物.png" style="height: 40px">
              <i class="el-icon-close" @click="toggleMenu"></i>
            </div>
            <div class="mobile-menu-list">
              <!-- 个人中心 -->
              <div class="mobile-menu-item" @click="handleMenuClick('personal-center')">
                <i class="el-icon-user"></i>
                <span>个人中心</span>
              </div>

              <!-- 订单中心分组 -->
              <div class="mobile-menu-section">
                <div class="mobile-menu-section-title" @click="toggleMobileSection('order')">
                  <i class="el-icon-document"></i>
                  <span>订单中心</span>
                  <span class="section-arrow" :class="{ 'is-open': mobileSectionStates.order }"></span>
                </div>
                <div v-if="mobileSectionStates.order" class="mobile-submenu">
                  <div class="mobile-submenu-item" @click="handleMenuClick('new-user-orders')">我的订单</div>
                  <div class="mobile-submenu-item" @click="handleMenuClick('courier-record')">邮寄记录</div>
                  <div class="mobile-submenu-item" @click="handleMenuClick('recycle-record')">回收记录</div>
                  <div class="mobile-submenu-item" @click="handleMenuClick('appraise-new')">订单评价</div>
                </div>
              </div>

              <!-- 会员中心分组 -->
              <div class="mobile-menu-section">
                <div class="mobile-menu-section-title" @click="toggleMobileSection('member')">
                  <i class="el-icon-medal"></i>
                  <span>会员中心</span>
                  <span class="section-arrow" :class="{ 'is-open': mobileSectionStates.member }"></span>
                </div>
                <div v-if="mobileSectionStates.member" class="mobile-submenu">
                  <div class="mobile-submenu-item" @click="handleMenuClick('new-member')">我的会员</div>
                  <div v-if="isMemberAdminFlag" class="mobile-submenu-item" @click="handleMenuClick('account-auth')">账户授权</div>
                </div>
              </div>

              <!-- 账户设置分组 -->
              <div class="mobile-menu-section">
                <div class="mobile-menu-section-title" @click="toggleMobileSection('account')">
                  <i class="el-icon-setting"></i>
                  <span>账户设置</span>
                  <span class="section-arrow" :class="{ 'is-open': mobileSectionStates.account }"></span>
                </div>
                <div v-if="mobileSectionStates.account" class="mobile-submenu">
                  <div class="mobile-submenu-item" @click="handleMenuClick('/newUser/entrustInfo')">委托信息</div>
                  <div class="mobile-submenu-item" @click="handleMenuClick('/newUser/my-points')">我的积分</div>
                  <div class="mobile-submenu-item" @click="handleMenuClick('/newUser/receivingAddress')">寄样地址</div>
                  <div class="mobile-submenu-item" @click="handleMenuClick('/newUser/myCoupon')">优惠卡券</div>
                </div>
              </div>

              <!-- 预下单 -->
              <div class="mobile-menu-item" @click="handleMenuClick('pre-order-list')">
                <i class="el-icon-shopping-cart-2"></i>
                <span>预下单 ({{cartNumber}})</span>
              </div>
            </div>

            <div class="mobile-menu-footer">
              <div class="mobile-menu-user-info">
                <i class="el-icon-user"></i>
                <span>{{ getPhone(true) }}</span>
              </div>
              <div class="mobile-menu-logout" @click="loginOut">
                <i class="el-icon-switch-button"></i>
                <span>退出登录</span>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- 可拖动的悬浮反馈图标 - 支持收起/展开 -->
    <div
      class="feedback-fab-wrapper"
      :class="{ 'collapsed': isFabCollapsed }"
      :style="fabWrapperStyle"
      @mouseenter="handleFabHover"
      @mouseleave="handleFabLeave"
    >
      <!-- 收起状态的小圆点 -->
      <div
        v-if="isFabCollapsed"
        class="fab-collapsed-dot"
        @mousedown="handleMouseDown"
        @touchstart="handleTouchStart"
      >
        <i class="el-icon-chat-dot-round"></i>
      </div>

      <div
        v-else
        class="feedback-fab"
        :class="{ 'mobile-fab': isMobile, 'dragging': isDragging }"
        @mousedown="handleMouseDown"
        @touchstart="handleTouchStart"
      >
        <i class="el-icon-chat-dot-round"></i>
        <span class="feedback-text" v-if="!isMobile">意见反馈</span>
        <!-- 收起按钮 - 使用更加明确的事件阻止 -->
        <div class="collapse-btn" @click.stop.prevent="toggleCollapse">
          <i class="el-icon-minus"></i>
        </div>
      </div>
    </div>

    <!-- 红白风格的可拖动反馈弹窗 - 包含客服二维码 -->
    <div
      v-if="feedbackDialogVisible"
      class="feedback-dialog"
      :style="dialogStyle"
    >
      <div class="dialog-header" @mousedown="startDialogDrag" @touchstart="startDialogDrag">
        <span>意见反馈</span>
        <i class="el-icon-close close-icon" @click.stop="closeFeedbackDialog"></i>
      </div>
      <div class="dialog-content">
        <textarea
          v-model="feedbackContent"
          placeholder="请详细描述您的问题或建议..."
          maxlength="500"
          rows="5"
        ></textarea>

        <!-- 客服二维码区域 -->
        <div class="customer-service-area">
          <div class="divider">
            <span class="divider-text">或扫码联系客服</span>
          </div>
          <div class="qrcode-wrapper">
            <img
              :src="qrCodeSrc"
              alt="客服二维码"
              class="qrcode-thumb"
            >
          </div>
        </div>

        <div class="dialog-footer">
          <button class="submit-btn" @click="submitFeedback" :disabled="submitting">
            {{ submitting ? '提交中...' : '提交反馈' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {EventBus} from "@/utils/eventBus";
import {getCartCount} from "@/api/clCartDetail";
import {getPhone, removeToken} from "@/utils/auth";
import {addClFeedback} from "@/api/order";
import {client_logout} from "@/utils/login";
import { isMember, isMemberAdmin } from '@/api/member';

export default {
  name: 'order',
  data() {
    return {
      cartNumber: 0,
      isMobile: false,
      menuVisible: false,
      // 图标拖拽相关
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      dragStartPosX: 0,
      dragStartPosY: 0,
      positionX: 30,
      positionY: 30,
      windowWidth: 0,
      windowHeight: 0,
      fabWidth: 56,
      fabHeight: 56,
      // 拖拽标记（用于区分点击和拖拽）
      hasMoved: false,
      // 收起/展开相关
      isFabCollapsed: false,
      hoverTimer: null,
      // 弹窗相关
      feedbackDialogVisible: false,
      feedbackContent: '',
      submitting: false,
      // 弹窗拖拽相关
      isDialogDragging: false,
      dialogDragStartX: 0,
      dialogDragStartY: 0,
      dialogPositionX: 0,
      dialogPositionY: 0,
      dialogWidth: 420,
      dialogHeight: 480,
      // 二维码相关
      qrCodeSrc: require('../../static/index/咨询二维码.png'),
      // 移动端菜单展开状态
      mobileSectionStates: {
        order: false,
        member: false,
        account: false
      },
      // 权限控制相关
      isMemberFlag: true,
      isMemberAdminFlag: true
    }
  },
  computed: {
    fabWrapperStyle() {
      return {
        left: this.positionX + 'px',
        bottom: this.positionY + 'px'
      };
    },
    dialogStyle() {
      return {
        left: this.dialogPositionX + 'px',
        top: this.dialogPositionY + 'px',
        width: this.dialogWidth + 'px'
      };
    }
  },
  created() {
    this.checkMobile();
    this.fetchCartNumber();
    this.updateWindowSize();
    this.judgeMemberPermission();
    // 从localStorage读取收起状态
    const savedState = localStorage.getItem('feedbackFabCollapsed');
    if (savedState !== null) {
      this.isFabCollapsed = savedState === 'true';
    }
    EventBus.$on('update-cart-count', this.fetchCartNumber);
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('resize', this.updateWindowSize);
    // 全局鼠标/触摸移动和结束事件
    window.addEventListener('mousemove', this.onMouseMove);
    window.addEventListener('mouseup', this.onMouseUp);
    window.addEventListener('touchmove', this.onTouchMove, { passive: false });
    window.addEventListener('touchend', this.onTouchEnd);
    // 弹窗拖拽事件
    window.addEventListener('mousemove', this.onDialogDrag);
    window.addEventListener('mouseup', this.stopDialogDrag);
    window.addEventListener('touchmove', this.onDialogDrag, { passive: false });
    window.addEventListener('touchend', this.stopDialogDrag);
  },
  beforeDestroy() {
    EventBus.$off('update-cart-count', this.fetchCartNumber);
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('resize', this.updateWindowSize);
    window.removeEventListener('mousemove', this.onMouseMove);
    window.removeEventListener('mouseup', this.onMouseUp);
    window.removeEventListener('touchmove', this.onTouchMove);
    window.removeEventListener('touchend', this.onTouchEnd);
    window.removeEventListener('mousemove', this.onDialogDrag);
    window.removeEventListener('mouseup', this.stopDialogDrag);
    window.removeEventListener('touchmove', this.onDialogDrag);
    window.removeEventListener('touchend', this.stopDialogDrag);
    if (this.hoverTimer) {
      clearTimeout(this.hoverTimer);
    }
  },
  methods: {
    getPhone,

    updateWindowSize() {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
      this.ensureInViewport();
    },

    ensureInViewport() {
      this.$nextTick(() => {
        const el = this.$el.querySelector('.feedback-fab, .fab-collapsed-dot');
        if (el) {
          this.fabWidth = el.offsetWidth;
          this.fabHeight = el.offsetHeight;
        }
        let newX = this.positionX;
        let newY = this.positionY;
        const maxX = this.windowWidth - this.fabWidth - 10;
        const maxY = this.windowHeight - this.fabHeight - 10;
        newX = Math.min(Math.max(10, newX), maxX);
        newY = Math.min(Math.max(10, newY), maxY);
        if (newX !== this.positionX || newY !== this.positionY) {
          this.positionX = newX;
          this.positionY = newY;
        }
      });
    },

    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
      if (!this.isMobile) {
        this.menuVisible = false;
      }
      if (this.isMobile) {
        // 移动端初始位置 - 右下角，距离右侧20px，距离底部80px
        this.positionX = this.windowWidth - 64;
        this.positionY = 80;
        this.dialogWidth = window.innerWidth - 40;
        this.dialogHeight = 480;
      } else {
        this.positionX = 30;
        this.positionY = 30;
        this.dialogWidth = 420;
        this.dialogHeight = 480;
      }
      this.dialogPositionX = (this.windowWidth - this.dialogWidth) / 2;
      this.dialogPositionY = (this.windowHeight - this.dialogHeight) / 2;
      this.ensureInViewport();
    },

    handleResize() {
      this.checkMobile();
    },

    // 收起/展开功能
    toggleCollapse() {
      this.isFabCollapsed = !this.isFabCollapsed;
      localStorage.setItem('feedbackFabCollapsed', this.isFabCollapsed);
      this.$nextTick(() => {
        this.ensureInViewport();
      });
    },

    handleFabHover() {
      if (!this.isMobile && this.isFabCollapsed) {
        if (this.hoverTimer) {
          clearTimeout(this.hoverTimer);
        }
        this.hoverTimer = setTimeout(() => {
          this.isFabCollapsed = false;
          localStorage.setItem('feedbackFabCollapsed', false);
          this.$nextTick(() => {
            this.ensureInViewport();
          });
        }, 300);
      }
    },

    handleFabLeave() {
      if (!this.isMobile && !this.isFabCollapsed) {
        if (this.hoverTimer) {
          clearTimeout(this.hoverTimer);
        }
        this.hoverTimer = setTimeout(() => {
          this.isFabCollapsed = true;
          localStorage.setItem('feedbackFabCollapsed', true);
          this.$nextTick(() => {
            this.ensureInViewport();
          });
        }, 1000);
      }
    },
    linkToAnalysis() {
      const url = 'http://www.simr.ac.cn/'
      window.open(url, '_blank')
    },

    // ========== 拖拽逻辑 ==========
    // 鼠标按下（PC端）
    handleMouseDown(e) {
      this.hasMoved = false;
      // 记录起始位置，用于判断是否移动
      this.dragStartPosX = e.clientX;
      this.dragStartPosY = e.clientY;

      // 获取当前元素的边界
      const el = this.$el.querySelector('.feedback-fab, .fab-collapsed-dot');
      if (!el) return;

      const rect = el.getBoundingClientRect();
      // 计算偏移量（鼠标位置相对于元素左上角）
      this.dragStartX = e.clientX - rect.left;
      // 对于 bottom 定位，计算鼠标位置相对于元素底部的距离
      this.dragStartY = rect.bottom - e.clientY;

      e.preventDefault();
      e.stopPropagation();
    },

    // 触摸开始（移动端）
    handleTouchStart(e) {
      this.hasMoved = false;
      const touch = e.touches[0];

      // 记录起始位置
      this.dragStartPosX = touch.clientX;
      this.dragStartPosY = touch.clientY;

      const el = this.$el.querySelector('.feedback-fab, .fab-collapsed-dot');
      if (!el) return;

      const rect = el.getBoundingClientRect();
      this.dragStartX = touch.clientX - rect.left;
      this.dragStartY = rect.bottom - touch.clientY;

      e.preventDefault();
      e.stopPropagation();
    },

    // 鼠标移动
    onMouseMove(e) {
      if (this.dragStartX === 0 && this.dragStartY === 0) return;

      // 计算移动距离
      const moveX = Math.abs(e.clientX - this.dragStartPosX);
      const moveY = Math.abs(e.clientY - this.dragStartPosY);

      // 移动超过5px才认为是拖拽
      if (moveX > 5 || moveY > 5) {
        this.hasMoved = true;
        this.isDragging = true;
      }

      if (!this.hasMoved) return;

      // 计算新的 left 和 bottom
      let newLeft = e.clientX - this.dragStartX;
      let newBottom = this.windowHeight - e.clientY - this.dragStartY;

      // 边界限制
      const maxLeft = this.windowWidth - this.fabWidth - 10;
      const minLeft = 10;
      const maxBottom = this.windowHeight - this.fabHeight - 10;
      const minBottom = 10;

      newLeft = Math.min(Math.max(minLeft, newLeft), maxLeft);
      newBottom = Math.min(Math.max(minBottom, newBottom), maxBottom);

      this.positionX = newLeft;
      this.positionY = newBottom;
    },

    // 触摸移动
    onTouchMove(e) {
      if (this.dragStartX === 0 && this.dragStartY === 0) return;

      const touch = e.touches[0];

      // 计算移动距离
      const moveX = Math.abs(touch.clientX - this.dragStartPosX);
      const moveY = Math.abs(touch.clientY - this.dragStartPosY);

      // 移动超过5px才认为是拖拽
      if (moveX > 5 || moveY > 5) {
        this.hasMoved = true;
        this.isDragging = true;
      }

      if (!this.hasMoved) return;

      let newLeft = touch.clientX - this.dragStartX;
      let newBottom = this.windowHeight - touch.clientY - this.dragStartY;

      const maxLeft = this.windowWidth - this.fabWidth - 10;
      const minLeft = 10;
      const maxBottom = this.windowHeight - this.fabHeight - 10;
      const minBottom = 10;

      newLeft = Math.min(Math.max(minLeft, newLeft), maxLeft);
      newBottom = Math.min(Math.max(minBottom, newBottom), maxBottom);

      this.positionX = newLeft;
      this.positionY = newBottom;

      e.preventDefault();
    },

    // 鼠标松开 - 关键：在这里判断是点击还是拖拽
    onMouseUp(e) {
      // 如果没有移动过，说明是点击
      if (!this.hasMoved && this.dragStartX !== 0) {
        this.openFeedback();
      }

      // 重置状态
      this.dragStartX = 0;
      this.dragStartY = 0;
      this.hasMoved = false;

      setTimeout(() => {
        this.isDragging = false;
      }, 50);
    },

    // 触摸结束
    onTouchEnd(e) {
      // 如果没有移动过，说明是点击
      if (!this.hasMoved && this.dragStartX !== 0) {
        this.openFeedback();
      }

      // 重置状态
      this.dragStartX = 0;
      this.dragStartY = 0;
      this.hasMoved = false;

      setTimeout(() => {
        this.isDragging = false;
      }, 50);
    },

    // ========== 弹窗拖拽 ==========
    startDialogDrag(e) {
      // 如果点击的是关闭按钮，不触发拖拽
      if (e.target.classList.contains('el-icon-close') ||
        e.target.classList.contains('close-icon')) {
        return;
      }
      this.isDialogDragging = true;
      const clientX = e.clientX || (e.touches && e.touches[0].clientX);
      const clientY = e.clientY || (e.touches && e.touches[0].clientY);
      this.dialogDragStartX = clientX - this.dialogPositionX;
      this.dialogDragStartY = clientY - this.dialogPositionY;
      e.preventDefault();
    },

    onDialogDrag(e) {
      if (!this.isDialogDragging) return;
      const clientX = e.clientX || (e.touches && e.touches[0].clientX);
      const clientY = e.clientY || (e.touches && e.touches[0].clientY);
      let newLeft = clientX - this.dialogDragStartX;
      let newTop = clientY - this.dialogDragStartY;
      const maxLeft = this.windowWidth - this.dialogWidth;
      const minLeft = 0;
      const maxTop = this.windowHeight - this.dialogHeight;
      const minTop = 0;
      newLeft = Math.min(Math.max(minLeft, newLeft), maxLeft);
      newTop = Math.min(Math.max(minTop, newTop), maxTop);
      this.dialogPositionX = newLeft;
      this.dialogPositionY = newTop;
      if (e.preventDefault) e.preventDefault();
    },

    stopDialogDrag() {
      this.isDialogDragging = false;
    },

    toggleMenu() {
      this.menuVisible = !this.menuVisible;
      if (this.menuVisible) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },

    handleMenuClick(path) {
      this.menuVisible = false;
      document.body.style.overflow = '';
      if (path && typeof path === 'string') {
        if (path.startsWith('/')) {
          this.$router.push(path);
        } else {
          this.linkTo(path);
        }
      }
    },

    toggleMobileSection(section) {
      this.$set(this.mobileSectionStates, section, !this.mobileSectionStates[section]);
    },

    fetchCartNumber() {
      getCartCount().then((res) => {
        if (res.code === 200) {
          this.cartNumber = res.data || 0;
        }
      });
    },

    linkTo(name) {
      this.$router.push({name: name});
    },

    loginOut() {
      this.$confirm('确定退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        client_logout()
      }).catch(() => {});
    },

    // 判断会员权限
    judgeMemberPermission() {
      isMemberAdmin().then(adminRes => {
        if (adminRes.code === 200 && adminRes.data === false) {
          this.isMemberAdminFlag = false;
        }
      }).catch(error => {
        console.error('管理员权限检查失败:', error)
      });

      isMember().then(memberRes => {
        if (memberRes.code === 200 && memberRes.data === false) {
          this.isMemberFlag = false;
        }
      }).catch(error => {
        console.error('会员权限检查失败:', error)
      });
    },

    openFeedback() {
      this.feedbackDialogVisible = true;
      this.feedbackContent = '';
      this.submitting = false;
      this.dialogPositionX = (this.windowWidth - this.dialogWidth) / 2;
      this.dialogPositionY = (this.windowHeight - this.dialogHeight) / 2;
    },

    closeFeedbackDialog() {
      this.feedbackDialogVisible = false;
      this.feedbackContent = '';
    },

    submitFeedback() {
      const content = this.feedbackContent.trim();
      if (!content) {
        this.$message.warning('反馈内容不能为空');
        return;
      }
      if (content.length > 500) {
        this.$message.warning('反馈内容不能超过500字');
        return;
      }
      this.submitting = true;
      addClFeedback({content: content}).then(res => {
        if (res.code === 200) {
          this.$message.success('感谢您的反馈！');
          this.closeFeedbackDialog();
        } else {
          this.$message.error(res.msg || '反馈失败，请稍后重试');
        }
      }).catch(() => {
        this.$message.error('网络错误，请稍后重试');
      }).finally(() => {
        this.submitting = false;
      });
    }
  }
}
</script>

<style scoped>
.top-bar {
  display: flex;
  justify-content: space-between;
  padding: 10px 200px;
  color: #000000;
  background-color: white;
  border-radius: 0 0 8px 8px;
  border-bottom: 1px solid #efeded;
  transition: all 0.3s ease;
  position: relative;
}

.left {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;

  &:hover {
    color: red;
  }
}

.right {
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.desktop-menu {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.to-order,
.to-member,
.to-mine,
.to-pre-order {
  cursor: pointer;

  &:hover {
    color: red;
  }
}

.home-page {
  font-size: 13px;
}

/* 反馈图标容器 */
.feedback-fab-wrapper {
  position: fixed;
  z-index: 999;
  transition: none;
}

/* 收起状态的小圆点 */
.fab-collapsed-dot {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #e64545 0%, #cf3535 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  animation: fadeInUp 0.5s ease;
  -webkit-tap-highlight-color: transparent;

  i {
    font-size: 20px;
    color: white;
    pointer-events: none;
  }

  &:active {
    cursor: grabbing;
  }

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(230, 69, 69, 0.4);
  }
}

/* 悬浮反馈按钮样式 */
.feedback-fab {
  background: linear-gradient(135deg, #e64545 0%, #cf3535 100%);
  color: white;
  width: auto;
  height: 44px;
  border-radius: 44px;
  padding: 0 16px 0 20px;
  gap: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-tap-highlight-color: transparent;
  position: relative;

  i {
    font-size: 18px;
    transition: transform 0.3s ease;
    pointer-events: none;
  }

  &:active {
    cursor: grabbing;
  }

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 6px 20px rgba(230, 69, 69, 0.4);
    background: linear-gradient(135deg, #cf3535 0%, #b82a2a 100%);

    i {
      transform: rotate(15deg);
    }
  }
}

.feedback-text {
  font-size: 14px;
  font-weight: 500;
  pointer-events: none;
}

/* 收起按钮 */
.collapse-btn {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid rgba(255, 255, 255, 0.3);
  margin-left: 8px;
  padding-left: 8px;
  cursor: pointer;
  transition: all 0.2s ease;

  i {
    font-size: 14px;
    margin: 0;
    pointer-events: none;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    transform: scale(1.1);
  }
}

.feedback-fab.dragging {
  opacity: 0.9;
  transition: none;
  cursor: grabbing;
}

/* 移动端反馈按钮调整 */
.mobile-fab {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  padding: 0;

  i {
    font-size: 20px;
  }

  .feedback-text {
    display: none;
  }

  .collapse-btn {
    display: none;
  }
}

/* 移动端收起状态的小圆点 */
@media (max-width: 768px) {
  .fab-collapsed-dot {
    width: 44px;
    height: 44px;

    i {
      font-size: 22px;
    }
  }
}

/* 红白风格的可拖动反馈弹窗 */
.feedback-dialog {
  position: fixed;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  z-index: 1002;
  overflow: hidden;
  border: 1px solid #ffe0e0;
}

.dialog-header {
  background: linear-gradient(135deg, #e64545 0%, #cf3535 100%);
  padding: 14px 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
  font-weight: 500;
  user-select: none;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }
}

.dialog-header span {
  flex: 1;
  font-size: 16px;
  pointer-events: none;
}

.close-icon {
  cursor: pointer;
  font-size: 18px;
  padding: 4px;
  border-radius: 50%;
  transition: background 0.2s;
}

.close-icon:hover {
  background: rgba(255, 255, 255, 0.2);
}

.dialog-content {
  padding: 20px;
  max-height: calc(100% - 52px);
  overflow-y: auto;
}

.dialog-content textarea {
  width: 100%;
  border: 1px solid #ffcccc;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  resize: vertical;
  font-family: inherit;
  transition: border 0.2s;
  box-sizing: border-box;
}

.dialog-content textarea:focus {
  outline: none;
  border-color: #e64545;
  box-shadow: 0 0 0 2px rgba(230, 69, 69, 0.1);
}

/* 客服二维码区域 */
.customer-service-area {
  margin-top: 20px;
  text-align: center;
}

.divider {
  position: relative;
  margin: 16px 0;
  text-align: center;
}

.divider::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: 1px;
  background: #e8e8e8;
}

.divider-text {
  position: relative;
  background: white;
  padding: 0 12px;
  font-size: 12px;
  color: #999;
}

.qrcode-wrapper {
  display: inline-block;
  text-align: center;
  transition: transform 0.2s;
}

.qrcode-thumb {
  height: 160px;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 6px;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
}

.submit-btn {
  background: linear-gradient(135deg, #e64545 0%, #cf3535 100%);
  border: none;
  color: white;
  padding: 8px 24px;
  border-radius: 24px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.submit-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(230, 69, 69, 0.3);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* 移动端样式 */
.mobile-top-bar {
  padding: 10px 15px;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.mobile-right {
  position: relative;
}

.mobile-menu-icon {
  cursor: pointer;
  padding: 8px;
  font-size: 17px;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  &:hover {
    color: red;
  }
}

/* 侧滑菜单遮罩层 */
.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 侧滑菜单内容 */
.mobile-menu-content {
  position: fixed;
  top: 0;
  right: 0;
  width: 280px;
  height: 100%;
  background-color: white;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  animation: slideIn 0.3s ease;
  display: flex;
  flex-direction: column;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

/* 菜单头部 */
.mobile-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
  background: linear-gradient(135deg, #ffffff 0%, #ff4f4f 100%);
  color: white;
}

.mobile-menu-header .el-icon-close {
  font-size: 20px;
  cursor: pointer;
  padding: 5px;
  color: #333;

  &:hover {
    opacity: 0.8;
  }
}

/* 菜单列表 */
.mobile-menu-list {
  flex: 1;
  padding: 10px 0;
  overflow-y: auto;
}

.mobile-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 1px solid #f5f5f5;

  i {
    font-size: 18px;
    color: #666;
    transition: all 0.3s ease;
  }

  span {
    font-size: 14px;
    color: #333;
  }

  &:hover {
    background-color: #f8f9fa;
    padding-left: 25px;

    i {
      color: #ff4444;
    }

    span {
      color: #ff4444;
    }
  }
}

/* 分组菜单样式 */
.mobile-menu-section {
  border-bottom: 1px solid #f5f5f5;
}

.mobile-menu-section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  cursor: pointer;
  transition: all 0.3s ease;

  i {
    font-size: 18px;
    color: #666;
  }

  span {
    font-size: 14px;
    color: #333;
  }

  .section-arrow {
    margin-left: auto;
    font-size: 12px;
    color: #999;
  }

  &:hover {
    background-color: #f8f9fa;
    color: #ff4444;

    span {
      color: #ff4444;
    }

    i {
      color: #ff4444;
    }
  }
}

.mobile-submenu {
  background-color: #fafafa;
}

.mobile-submenu-item {
  padding: 10px 20px 10px 52px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #666;
  font-size: 13px;

  &:hover {
    background-color: #f0f0f0;
    color: #ff4444;
  }
}

/* 菜单底部 */
.mobile-menu-footer {
  border-top: 1px solid #f0f0f0;
  padding: 16px 20px;
}

.mobile-menu-user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  color: #666;
  font-size: 14px;

  i {
    font-size: 18px;
    color: #ff4444;
  }
}

.mobile-menu-logout {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  color: #ff4444;
  cursor: pointer;
  font-size: 14px;

  i {
    font-size: 18px;
  }

  &:active {
    opacity: 0.7;
  }
}

/* 滑动动画 */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
}

.slide-fade-enter .mobile-menu-content,
.slide-fade-leave-to .mobile-menu-content {
  transform: translateX(100%);
}

/* 平板适配 */
@media (max-width: 1024px) {
  .top-bar {
    padding: 10px 50px;
  }
}

@media (max-width: 768px) {
  .top-bar {
    padding: 10px 15px;
  }
  .section-arrow {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-right: 2px solid #333;
    border-bottom: 2px solid #333;
    transform: rotate(-45deg);  /* 默认向右 ▶ */
    transition: transform 0.2s ease;
    margin-left: auto; /* 如果想让箭头靠右，可以加上这行 */
  }

  .section-arrow.is-open {
    transform: rotate(45deg);   /* 展开向下 ▼ */
  }
  .desktop-menu {
    display: none;
  }

  .feedback-dialog {
    width: calc(100% - 40px) !important;
    max-height: 80vh;
  }

  /* 移动端收起按钮显示 */
  .feedback-fab .collapse-btn {
    display: none;
  }
}

@media (min-width: 769px) {
  .mobile-menu-icon {
    display: none;
  }
}

/* 小屏手机优化 */
@media (max-width: 480px) {
  .mobile-menu-content {
    width: 260px;
  }

  .mobile-menu-item {
    padding: 12px 16px;

    i, svg {
      font-size: 16px;
    }

    span {
      font-size: 13px;
    }
  }

  .mobile-menu-header {
    padding: 16px;
  }

  .user-info {
    font-size: 14px;

    i {
      font-size: 20px;
    }
  }

  .feedback-dialog {
    width: calc(100% - 30px) !important;
    left: 15px !important;
  }

  .qrcode-thumb {
    width: 80px;
    height: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/NewNavBar.vue